var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"User Targets"}},[_c('UserKPITargets',{attrs:{"crm_user_id":_vm.crm_user_id}})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"User Upskilling/Goals"}},[_c('UserUpskilling',{attrs:{"crm_user_id":_vm.crm_user_id}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }